/**
 * Fishing event system type definitions
 * Random events that trigger during fishing to break monotony
 */

/**
 * Types of random fishing events
 */
export enum FishingEventType {
  DOUBLE_HOOK = 'double_hook',         // Catch 2 fish instead of 1
  FEEDING_FRENZY = 'feeding_frenzy',   // Next 3 casts: 95% catch, 1.5s time
  BIG_ONE = 'big_one',                 // Guaranteed RARE+ quality
  LUCKY_CATCH = 'lucky_catch',         // +50% gold value bonus
  RARE_SIGHTING = 'rare_sighting',     // Guaranteed rare/epic species
  BROKEN_LINE = 'broken_line',         // Lose catch, +20% catch chance for 2 casts
}

/**
 * A fishing event that triggered on a cast
 */
export interface FishingEvent {
  type: FishingEventType;
  name: string;
  description: string;
  emoji: string;
  isNegative: boolean;
}

/**
 * An active multi-cast effect (Frenzy or Consolation)
 */
export interface ActiveFishingEffect {
  type: FishingEventType;
  remainingCharges: number;
}

/**
 * Fishing event definitions with weights
 */
export interface FishingEventDefinition {
  type: FishingEventType;
  name: string;
  description: string;
  emoji: string;
  weight: number;       // Relative weight for weighted selection
  isNegative: boolean;
}
